import { Component, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { customer_request_lang } from "../../language/customer_request";
import { MyserviceService } from '../../provider/myservice.service';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import * as L from 'leaflet';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { thLocale } from 'ngx-bootstrap/locale';
defineLocale('engb', enGbLocale);
defineLocale('th', thLocale);
declare var url;
declare var report_url;
declare var report_service_url;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}


class request {
  request_id: string;
  request_date: string;
  customer_name: string;
  remark: string;
  flag: string;
}

@Component({
  selector: 'app-customer-request',
  templateUrl: './customer-request.component.html',
  styleUrls: ['./customer-request.component.scss']
})
export class CustomerRequestComponent implements AfterViewInit {
  map;
  name: any;
  lat = 19.14008388;
  lon = 99.91081981;
  marker;
  municipality_id = '';
  token = '';
  database = '';
  request_id = '';
  dtOptions: DataTables.Settings = {};
  dtOptions2: DataTables.Settings = {};
  requests: request[];
  polygon;
  lang = '';
  language: any;
  isLoading = true;
  showPage = false;
  showRequest = false;
  geoJson: any;
  daysInmonth;
  remark = null;
  days;
  type = undefined;
  day = new Date().getDay() + 1;
  month = new Date().getMonth() + 1;
  year = new Date().getFullYear();
  showbth_confrim = true;
  years: any;
  mapbox: any = null;
  showedit: boolean;
  pin_icon = null;
  submitted = false;
  date = {
    end_date: '',
    start_date: ''
  }
  constructor(
    private http: HttpClient,
    private service: MyserviceService,
    private chRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private localeService: BsLocaleService,
    private router: Router,
    private modalService: BsModalService) {
    this.language = customer_request_lang[this.lang];
  }

  ngAfterViewInit(): void {
    this.initMap();
  }

  private initMap(): void {
    var streets_satellite = L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
      attribution: 'Mapbox',
      tileSize: 512,
      zoomOffset: -1,
      maxZoom: 21,
      brightness: 1.2,
      id: 'mapbox/satellite-v9',
      accessToken: 'pk.eyJ1IjoidG9uZ3p6enoiLCJhIjoiY2s5N3ZuM3hiMGVzYTNncGt6cnVrZHE4eiJ9.jh_uPx9BkdNpdG1LdhenUw'
    })
    // ===================================================================================
    var mapbox_streets = L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
      attribution: 'Mapbox',
      tileSize: 512,
      zoomOffset: -1,
      maxZoom: 21,
      brightness: 1.2,
      id: 'mapbox/streets-v11',
      accessToken: 'pk.eyJ1IjoidG9uZ3p6enoiLCJhIjoiY2s5N3ZuM3hiMGVzYTNncGt6cnVrZHE4eiJ9.jh_uPx9BkdNpdG1LdhenUw'
    })

    var wmslayer = L.tileLayer.wms('http://203.150.210.26:8080/geoserver/gwc/service/wms', {
      layers: 'Pattaya:Satellite',
      format: 'image/png8',
      transparent: true,
    })

    var polygon = L.tileLayer.wms('http://203.150.210.26:8080/geoserver/gwc/service/wms', {
      layers: 'pattaya_290663',
      format: 'image/png8',
      transparent: true,
    })

    var baseLayers = {
      "Satellite_mapbox": streets_satellite,
      "Streets_mapbox": mapbox_streets
    };

    this.service.postData({}, "zone/get").then(async (e: any) => {
      const newdata = await e.data.map((feature: any) => {
        return {
          zone_id: feature.zone_id,
          id: feature.id,
          geometry: feature.coordinates,
          properties: feature.properties,
          type: feature.type,

        };
      });
      const newdata_ = await Promise.all(newdata);
      this.mapbox = newdata_;
      const bule = newdata_.filter((feature: any) => feature.zone_idd == null);

      var css = '.text-label { background-color: transparent; color: white;font-size: 15px;border: none; }';
      var style = document.createElement('style');
      style.type = 'text/css';
      style.appendChild(document.createTextNode(css));
      document.head.appendChild(style);

      const zone = L.geoJSON(bule, {
        style: { color: "blue" },
        onEachFeature: (feature: any, layer: any) => {
          console.log(this.requests);
          const data = this.requests
          // this.map.setView([+this.lat, +this.lon], 13);
          layer.bindPopup(`<h5>${this.lang != "EN" ? '' : 'รายละเอียดคำร้อง'}</h5>
          <p style="font-size: 12px;">${this.lang != "EN" ? '' : 'วันที่ยื่นคำร้อง'}: ${data}</p>
            
            `)
          // layer.bindTooltip(feature.properties.zone_id, {
          //   permanent: true,
          //   direction: 'center',
          //   className: 'text-label',
          //   opacity: 0.9
          // }).openTooltip();

        },
      });
      // <p style="font-size: 12px;">${this.lang != "EN" ? '' : 'ชื่อผู้ขอยื่นคำร้อง'}: ${data[0].customer_name + ' ' + data[0].customer_surname}</p>
      //         // <p style="font-size: 12px;">${this.lang != "EN" ? '' : 'รายละเอียดค่าธรรมเนียม'}: ${data[0].request_desc}</p>
      //         // <p style="font-size: 12px;">${this.lang != "EN" ? '' : ''}: ${data[0].request_desc}</p>
      zone.addTo(this.map);
      zone.on('mouseover', (e) => {
        console.log(e);

      })
    });
    this.map = L.map('map', {
      center: [this.lat, this.lon],
      zoom: 20,
      layers: [streets_satellite],
      brightness: 1.2,
      maxZoom: 21,
    });
    var LeafIcon = L.Icon.extend({
      options: {
        iconSize: [26, 26],
        shadowSize: [16, 16],
      },
    });

    var customIcon = L.icon({
      iconUrl: '../../../assets/img/marker-icon-2x.png',
      iconSize: [30, 45],
      iconAnchor: [23, 35],
      popupAnchor: [-2, -38]
    });

  }

  ngOnInit() {
    const show = JSON.parse(sessionStorage.getItem('user')).role
    console.log(show);
    if (!(show == 1 || show == 2)) {
      this.showbth_confrim = false;
    }
    if (localStorage.getItem('year') != null) {
      this.year = parseInt(localStorage.getItem('year'));
      localStorage.removeItem('year');
    }

    if (parseInt(this.year.toString()) < 2500) {
      this.year = this.year + 543;
    }

    this.years = [];
    for (var i = 0; i < 5; i++) {
      this.years.push(this.year - i);
    }

    let year_db = 0;
    if (this.year > 2500) {
      year_db = this.year - 543;
    } else {
      year_db = this.year
    }

    this.daysInmonth = new Date(parseInt(year_db.toString(), 10), parseInt(this.month.toString(), 10), 0).getDate();
    this.daysInmonth = parseInt(this.daysInmonth.toString(), 10);
    this.days = [];
    for (var i = 0; i <= this.daysInmonth - 1; i++) {
      this.days.push(i + 1);
    }
    this.municipality_id = JSON.parse(sessionStorage.getItem('municipality')).municipality_id;

    if (sessionStorage.getItem('municipality') != undefined) {
      this.database = JSON.parse(sessionStorage.getItem('municipality')).municipality_id + '_fee'
    }

    if (sessionStorage.getItem('token') != undefined) {
      this.token = sessionStorage.getItem('token');
    }

    if (localStorage.getItem('month') != null) {
      if (localStorage.getItem('month').length > 1) {
        this.month = parseInt((localStorage.getItem('month')).match(/"([^']+)"/)[1]);
        localStorage.removeItem('month')
      }
      else {
        this.month = parseInt(localStorage.getItem('month'));

      }
    }

    if (localStorage.getItem('type') != null) {
      this.type = +JSON.parse(localStorage.getItem('type'));
      // localStorage.removeItem('type')
    }

    let dashboard = 'false';
    if (this.type != undefined) {
      dashboard = 'true';
    }
    else {
      this.type = "3";
    }
    localStorage.removeItem('type')
    const date_f = JSON.parse(localStorage.getItem('datefilter'))
    if (this.type == 4 && date_f != undefined) {
      this.date.end_date = date_f.end_date;
      this.date.start_date = date_f.start_date;
    }

    this.isLoading = false;
    this.showPage = true;
    const that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: true,
      order: [[0, 'desc']],
      processing: true,
      language: {
        emptyTable: '',
        zeroRecords: '',
      },
      ajax: (dataTablesParameters: any, callback) => {
        console.log('customer-request/get-customer-request_to_datatable')
        that.http
          .post<DataTablesResponse>(
            url + 'customer-request/get-customer-request_to_datatable?request_id=' + this.request_id,
            dataTablesParameters, {
            headers: new HttpHeaders({
              'Content-Type': 'application/json; charset=utf-8',
              'x-access-token': this.token,
              'database': this.database,
              'day': (this.day.toString().length == 1) ? '0' + this.day.toString() : this.day.toString(),
              'month': (this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString(),
              'year': (this.year - 543).toString(),
              'dashboard': dashboard,
              'type': this.type.toString(),
              'date_filter': JSON.stringify(this.date)

            })
          }
          ).subscribe(resp => {
            //debugger

            console.log(resp);
            that.requests = resp.data.map((item) => {
              var xy = 0;
              xy = parseInt(moment(item.request_date).format('YYYY'));

              if (xy < 2500) {
                xy = xy + 543;
              }

              item.request_date = moment(item.request_date).format('DD/MM/') + xy + ' ' + moment(item.request_date).format('HH:mm:ss');

              switch (item.flag) {
                case '0':
                  item.flag = 'ไม่อนุมัติ'
                  break;
                case '2':
                  item.flag = 'อนุมัติ'
                  break;
                default:
                  item.flag = 'รอดำเนินการ'
                  break;
              }
              return item;
            });
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
            localStorage.removeItem('month');
            localStorage.removeItem('year');
          });
      },
      columns: [{ data: 'customer_request.request_id' }, { data: 'to_char(customer_request.request_date,\'YYYY-MM-DD HH:mm:ss\')' }, { data: `customer.customer_name` }, { data: 'customer_request.remark' }, { data: `fee_type.fee_type_description` },
      { data: `(CASE WHEN customer_request.flag = '1' THEN 'รอดำเนินการ' WHEN customer_request.flag = '2' THEN 'อนุมัติ' WHEN customer_request.flag = '0' THEN 'ไม่อนุมัติ' END) ` }, { data: 'customer_request.user_id' }, { data: '' }, { data: '' }]
    };

    this.dtOptions2 = {
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: true,
      processing: true,
      language: {
        emptyTable: '',
        zeroRecords: '',
      },
      ajax: (dataTablesParameters: any, callback) => {
        console.log('customer-request/get-customer-request_to_datatable')
        that.http
          .post<DataTablesResponse>(
            url + 'customer-request/get-customer-request_to_datatable?request_id=' + this.request_id,
            dataTablesParameters, {
            headers: new HttpHeaders({
              'Content-Type': 'application/json; charset=utf-8',
              'x-access-token': this.token,
              'database': this.database,
              'date_filter': JSON.stringify(this.date)

            })
          }
          ).subscribe(resp => {
            //debugger
            that.requests = resp.data.map((item) => {
              var xy = 0;
              xy = parseInt(moment(item.request_date).format('YYYY'));

              if (xy < 2500) {
                xy = xy + 543;
              }

              item.request_date = moment(item.request_date).format('DD/MM/') + xy + ' ' + moment(item.request_date).format('HH:mm:ss');

              switch (item.flag) {
                case '0':
                  item.flag = 'ไม่อนุมัติ'
                  break;
                case '2':
                  item.flag = 'อนุมัติ'
                  break;
                default:
                  item.flag = 'รอดำเนินการ'
                  break;
              }
              return item;
            });
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          });
      },
      columns: [{ data: '' }, { data: '' }, { data: `customer.customer_name` }, { data: '' }, { data: `` }, { data: '' },
      { data: '' }, { data: `` }]
    };

    this.route.queryParams.subscribe(params => {
      this.lang = params['lang'];
      if (this.lang != 'EN' && this.lang != 'TH') {
        this.lang = localStorage.getItem('lang') == 'EN' ? 'EN' : 'TH';
        this.language = customer_request_lang[this.lang];
      } else {
        this.language = customer_request_lang[this.lang];
        localStorage.setItem('lang', this.lang);
      }
    });
  }

  approve(request) {
    if (request != undefined || this.requests.length == 1) {

      if (request == undefined) {
        request = this.requests[0];
      }

      if (request.flag == '1' || request.flag == 'รอดำเนินการ') {
        Swal.fire({
          title: this.language.approve_title,
          text: this.language.approve_detail,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.language.approve,
          cancelButtonText: this.language.approve_cancel
        }).then((result) => {
          if (result.value) {
            this.service.postData({ request_id: request.request_id, flag: '2' }, "customer-request/update").then((result: any) => {
              if (!result.code) {
                Swal.fire({
                  title: this.language.approve,
                  text: '',
                  type: 'success',
                  showCancelButton: false,
                  showConfirmButton: false,
                  timer: 2000
                }).then((result) => {
                  window.location.reload();
                })
              }
            }, err => {
              window.location.href = this.service.start_host
            })
          }
        })
      }
      else {
        Swal.fire({
          title: this.language.inform_title,
          text: this.language.inform_detail,
          type: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: this.language.inform_confirm
        }).then((result) => {
          if (result.value) { }
        })
      }
    }

  }

  notapprove(request) {
    if (request != undefined || this.requests.length == 1) {

      if (request == undefined) {
        request = this.requests[0];
      }

      if (request.flag == '1' || request.flag == 'รอดำเนินการ') {
        Swal.fire({
          title: this.language.approve_title,
          text: this.language.notapprove_detail,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.language.notapprove,
          cancelButtonText: this.language.approve_cancel
        }).then((result) => {
          if (result.value) {
            this.service.postData({ request_id: request.request_id, flag: '0' }, "customer-request/update").then((result: any) => {
              if (!result.code) {
                Swal.fire({
                  title: this.language.notapprove,
                  text: '',
                  type: 'success',
                  showCancelButton: false,
                  showConfirmButton: false,
                  timer: 2000
                }).then((result) => {
                  window.location.reload();
                })
              }
            }, err => {
              window.location.href = this.service.start_host
            })
          }
        })
      }
      else {
        Swal.fire({
          title: this.language.inform_title,
          text: this.language.inform_detail,
          type: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: this.language.inform_confirm
        }).then((result) => {
          if (result.value) { }
        })
      }
    }
  }

  show_marker(request) {
    function findPolygonCenter(polygon: number[][][]): { x: number, y: number } {
      const numVertices = polygon[0][0].length;
      let centerX = 0;
      let centerY = 0;

      for (let i = 0; i < numVertices; i++) {
        const vertex = polygon[0][0][i];
        centerX += vertex[0];
        centerY += vertex[1];
      }

      centerX /= numVertices;
      centerY /= numVertices;

      return { x: centerX, y: centerY };
    }
    const center = findPolygonCenter(JSON.parse(request.coordinates));
    console.log(center);
    this.map.setView([+center.y, +center.x], 20);
  }

  show_information(request) {
    var customIcon = L.icon({
      iconUrl: '../../../assets/img/marker-icon-2x.png',
      iconSize: [30, 45],
      iconAnchor: [23, 35],
      popupAnchor: [-2, -38]
    });
    if (request != undefined) {
      this.request_id = request.request_id;
      this.name = request.customer_name + ' ' + request.customer_surname;
      this.showPage = false;
      this.showRequest = true;
      this.requests = [];
      setTimeout(() => {
        this.initMap();

        let data_geojson = {
          "type": "FeatureCollection",
          "features": [
            {
              "type": "Feature",
              "properties": {},
              "geometry": {
                "type": "MultiPolygon",
                "coordinates": JSON.parse(request.coordinates)
              }
            }
          ]
        };
        console.log(data_geojson);
        this.polygon = L.geoJSON(data_geojson).addTo(this.map);

        // fit map to bounds of geojson layer
        this.map.fitBounds(this.polygon.getBounds());
      }, 500);
    }
  }
  edit(data: any) {
    // debugger
    console.log(data);
    this.showedit = true;
    this.showRequest = false;
    this.submitted = true;
    this.request_id;
    this.name;
    this.remark = data[0]
  }
  async save(data) {
    this.service.postData({ request_id: data.request_id, remark: data.remark }, "customer-request/update_remark").then((result: any) => {
      if (!result.code) {
        Swal.fire({
          text: '',
          type: 'success',
          showCancelButton: false,
          showConfirmButton: false,
          timer: 2000
        }).then((result) => {
          this.refresh();
        })
      }
    })
  }
  refresh() {
    this.showPage = true;
    this.showRequest = false;
    this.request_id = '';
    this.showedit = false;
  }

  print(row) {
    const municipality_id = this.service.getDatabase().substring(0, 5);
    var dateString = moment(row.request_date).format('MM-DD-YYYY');
    var x = moment(dateString, 'MM-DD-YYYY').locale('th-TH');
    var xy = 0;
    xy = parseInt(x.format('YYYY'));

    if (xy < 2500) {
      xy = xy + 543;
    }

    var request = {
      template: { name: 'request-general' },
      data:
      {
        "title": "คำร้องทั่วไป",
        "request_at": 'คำขอจากภาคสนาม',
        "request_date": x.format('DD'),
        "request_month": x.format('MMMM'),
        "request_year": xy,
        "request_customer": (row.customer_name == '' || row.customer_name == ' ') ? '-' : row.customer_name + ' ' + row.customer_surname,
        "request_age": "-",
        "request_race": row.customer_race,
        "request_nationality": "-",
        "request_house_number": '-',
        "request_house_moo": '-',
        "request_house_road": '-',
        "request_house_tambon": '-',
        "request_house_amphur": '-',
        "request_house_province": '-',
        "request_house_mobile": row.mobile,
        "request_to": "-",
        "request_desc1": (row.fee_type_description == '' || row.fee_type_description == ' ') ? '-' : row.fee_type_description+' ' + row.place_type_description,
        "request_desc2": (row.request_desc == '' || row.request_desc == ' ') ? '-' : row.request_desc,
        "request_desc3": "-",
        "request_desc4": "-",
        "request_desc5": "-",
        "opinion1": (row.opinion == '' || row.opinion == ' ') ? '-' : row.opinion,
        "opinion2": "-",
        "opinion3": "-",
        "opinion4": "-",
        "command1": (row.command_desc == '' || row.command_desc == ' ') ? '-' : row.command_desc,
        "request_general_id": (row.request_id == '' || row.request_id == ' ') ? '-' : row.request_id
      }
    };

    localStorage.setItem('dataOfPrint', JSON.stringify(request));
    window.open(report_url + "print-customer-request?municipality_id=" + municipality_id, "_blank");

  }

}
